import $ from "jquery";
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import PricingTableTotals from "../../common/pricing/totals.component.jsx";
import PricingTableContent from '../../pricing/PricingTableContentComponent.jsx';
import { BILLING_TYPE } from '../../state/invoice/InvoiceBillingType';
import { fetchPriceLevels } from '../../state/price-level/PriceLevelActions';
import { setPricingTableGroupItems, setPricingTableGroups, setPricingTableInitialState, setPricingTableItems } from '../../state/pricing/actions';
const uuidv4 = require('uuid/v4')

class PricingTableModal extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            invoice: this.props.invoice || null,
            object: props.object || props.invoice || props.quote,
            //can be an order
            quote: this.props.quote || null,
            className: this.props.className || '',
            modalId: this.props.modalId || 'pricing-table-modal-' + uuidv4(),
        }
        this.closeModal = this.closeModal.bind(this)
        this.setGlobalStateInitialValues = this.setGlobalStateInitialValues.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            invoice: nextProps.invoice || null,
            quote: nextProps.quote || null,
            object: nextProps.object || nextProps.invoice || nextProps.quote,
        })
    }

    componentDidMount() {
        $('#' + this.state.modalId).modal('show')
        if (!this.props.persistState) {
            this.setGlobalStateInitialValues()
        }
    }

    setGlobalStateInitialValues() {
        const object = this.state.object
        this.props.fetchPriceLevels()
        this.props.setPricingTableItems(object.attributes.items, object.id, object.attributes.totals, object.attributes.pricingTableId || "")
        this.props.setPricingTableGroups(object.attributes.groups, object.id)
        this.props.setPricingTableGroupItems(object.attributes.groups, object.attributes.items, object.id)
    }

    closeModal(event) {
        event.preventDefault()
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            this.props.onClose(event)
        }
    }

    render() {
        const object = this.state.object
        return <div className="modal fade"
            id={this.state.modalId}
            role="dialog"
            aria-labelledby="emailModalTitle"
            data-backdrop="static"
            data-keyboard="false"
            tabIndex="-1"
        >
            <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title mb-0 border-0 pb-0" id="emailModalTitle">
                            <FormattedMessage
                                id="common.pricing_table.modal.title"
                                defaultMessage="Pricing table of {identifier}"
                                values={{
                                    identifier: object.attributes.identifier,
                                }}
                            />
                        </h5>
                        <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className={"col-12 " + this.state.className}>
                                    <div >
                                        <div >
                                            <PricingTableContent
                                                persistState={this.props.persistState}
                                                tableId={object.attributes.pricingTableId || ""}
                                                projectId={object.attributes.projectId}
                                                currency={object.attributes.currency}
                                                allowEdit={false}
                                                sortable={false}
                                                mainObject={object.type}
                                                objectId={object.id}
                                                fromShowDetails={true}
                                            />
                                        </div>
                                    </div>
                                    <div className={"row mb-3"}>
                                        <div className={"col-md-12 pb-3"}>
                                            <PricingTableTotals
                                                totalClassName={"col-xl-8 col-lg-8 col-md-12"}
                                                allowEdit={false}
                                                rows={object.attributes.items}
                                                depositType={object.attributes.depositType}
                                                totals={object.attributes.totals}
                                                mainObjectId={object.id}
                                                depositAmount={object.attributes.depositAmount || '0'}
                                                depositRatio={object.attributes.depositRatio || 0}
                                                hideMargin={object.attributes.billingType === BILLING_TYPE.RETURN}
                                                mainObject={object.type}
                                                objectId={object.id}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" onClick={this.closeModal}>
                            <FormattedMessage
                                id="common.pricing_table.modal.close_btn"
                                defaultMessage="Close"
                            />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    }

}
const mapState = (state, props) => {
    return { ...props }
}
const mapDispatch = { setPricingTableItems, setPricingTableGroups, setPricingTableInitialState, setPricingTableGroupItems, fetchPriceLevels }
export default connect(mapState, mapDispatch)(injectIntl(PricingTableModal))






// WEBPACK FOOTER //
// ./src/quote/analytics/pricingtablemodal.component.jsx